// extracted by mini-css-extract-plugin
export var carrierIcon = "_y1-0";
export var carrierLogo = "_y1-1";
export var detailsSection = "_y1-2";